


















































import { Intervention } from "../../models/Intervention";
import { InterventionApi } from "../../api/InterventionApi";

export default {
    name: "InterventionModalPointageDisplay",
    props: {
        intervention: {
            type: Intervention,
            required: true,
        },
    },
    data() {
        return {
            imageUrl: null,
            loading: false,
            error: false,
            // Numéro du dernier chargement : une carte arrivée en retard
            // (intervention changée, onglet fermé) est libérée sans être
            // affichée.
            loadId: 0,
            InterventionApi: new InterventionApi(),
        };
    },
    created() {
        this.loadImage();
    },
    destroyed() {
        this.loadId++;
        this.releaseImage();
    },
    watch: {
        "intervention.maps_image_url": function () {
            this.loadImage();
        },
    },
    methods: {
        loadImage() {
            let self = this;
            let loadId = ++self.loadId;

            self.releaseImage();
            self.error = false;
            if (!self.intervention.maps_image_url) {
                self.loading = false;
                return;
            }

            self.loading = true;
            self.InterventionApi.getPointageImageObjectUrl(
                self.intervention.maps_image_url
            )
                .then(function (objectUrl) {
                    if (loadId !== self.loadId) {
                        URL.revokeObjectURL(objectUrl);
                        return;
                    }
                    self.imageUrl = objectUrl;
                    self.loading = false;
                })
                .catch(function () {
                    if (loadId === self.loadId) {
                        self.loading = false;
                        self.error = true;
                    }
                });
        },
        releaseImage() {
            if (this.imageUrl) {
                URL.revokeObjectURL(this.imageUrl);
                this.imageUrl = null;
            }
        },
    },
    computed: {
        coordsClient() {
            if (
                this.intervention.client &&
                this.intervention.client.adresse &&
                this.intervention.client.adresse.coord
            ) {
                return this.intervention.client.adresse.coord;
            }
        },
    },
};
